export class LinkUtils {
  public static readonly PUBLIC_LINK_REGEX = /^(\/[^/]*){0,3}/;
  public urlSuffix = '';
  public urlPrefix = '';

  constructor() {
    this.initLinkPrefix();
    this.initLinkSuffix();
  }
  public initLinkPrefix(): void {
    const vansPrefix = window.location.pathname.split('/')[1];
    this.urlPrefix = vansPrefix === 'vans' ? `/${vansPrefix}` : '';
  }
  public initLinkSuffix(): void {
    if (window.location.pathname.endsWith('.html')) {
      this.urlSuffix = '.html';
    }
  }
  public getPublicLink(link: string): string {
    if (link?.startsWith('/content/vans')) {
      return link.replace(LinkUtils.PUBLIC_LINK_REGEX, '/vans') + this.urlSuffix;
    }
    return link + this.urlSuffix;
  }
  public getImageLink(imageSrc: string): string {
    return this.urlPrefix + imageSrc;
  }
}
